import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";
import { clsx } from "clsx";
// icons
import copyIcon from "../../../../src/images/copy-icon.svg";
import imageIcon from "../../../../src/images/file-image.svg";
import jackeryLogo from "../../../../src/ExternalImages/jackeryLogo.svg";
import { ReactSVG } from "react-svg";
import { useMediaQuery } from "@mui/material";

const CouponItem = (props) => {
  const isMobile = useMediaQuery("(max-width:769px)");

  const { item } = props;
  const couponRef = useRef(null);
  const [isCopied, setIsCopied] = useState(false);
  const [isValidDate, setsValidDate] = useState(true);

  const handleCouponClick = () => {
    const range = document.createRange();
    range.selectNodeContents(couponRef.current);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand("copy");
    setIsCopied((prev) => !prev);
    setTimeout(() => {
      setIsCopied((prev) => !prev);
      selection.removeAllRanges();
    }, [1500]);
  };

  useEffect(() => {
    if (!!item?.["date Start"] && !!item?.["date End"]) {
      const dateFrom = new Date(item?.["date Start"]);
      const dateTo = new Date(item?.["date End"]);
      const dateCheck = new Date();
      dateCheck.setHours(0);
      dateCheck.setMinutes(0);
      dateCheck.setSeconds(0);
      dateCheck.setMilliseconds(0);
      setsValidDate(
        dateCheck.getTime() >= dateFrom.getTime() &&
          dateCheck.getTime() <= dateTo.getTime()
      );
    } else {
      setsValidDate(true);
    }
  }, []);

  return (
    isValidDate && (
      <div
        className={clsx("CouponItem flex-it", `theme-${item?.theme}`)}
        style={item?.bgColor ? { backgroundColor: item?.bgColor } : null}
      >
        <div className="coupon-logo">
          {!!item?.logo && item?.logo.indexOf("/local/") === -1 ? (
            <img
              src={item?.logo}
              alt={!!item?.Name ? item?.Name : "no title"}
            />
          ) : !!item?.logo && item?.logo.indexOf("/local/") !== -1 ? (
            <img
              alt={!!item?.Name ? item?.Name : "no title"}
              src={
                item?.logo?.toLowerCase()?.indexOf("jackery") !== -1
                  ? jackeryLogo
                  : ""
              }
              // src={`../../../../src/affiliateImages/${item?.logo?.replaceAll(
              //   "/local/",
              //   ""
              // )`}
            />
          ) : (
            <img src={imageIcon} alt={"no image"} />
          )}
        </div>
        <div className="coupon-data ">
          {!!item?.Coupon && (
            <div
              className={clsx(
                "coupon-font coupon-text",
                isMobile ? "" : "swiper-no-swiping"
              )}
            >
              Coupon code:{" "}
              <span
                className="flex-inline"
                ref={couponRef}
                onClick={() => handleCouponClick()}
              >
                {item?.Coupon}{" "}
                {<ReactSVG src={copyIcon} className="svg-icon" />}
              </span>
            </div>
          )}
          {!!item?.CouponEffect && (
            <div
              className={clsx(
                "coupon-font coupon-name",
                isMobile ? "" : "swiper-no-swiping"
              )}
            >
              <span className="coupon-effect">{item?.CouponEffect}</span>
            </div>
          )}
          {!!item?.["date Start"] && !!item?.["date End"] && (
            <div
              className={clsx(
                "coupon-font coupon-date",
                isMobile ? "" : "swiper-no-swiping"
              )}
            >
              <span className="coupon-effect">
                start: {item?.["date Start"]} End: {item?.["date End"]}
              </span>
            </div>
          )}
          {/* <div className="coupon-font coupon-effect">{item?.CouponEffect}</div> */}
          {/* Link:{" "} */}
          <a
            rel="noreferrer"
            target={"_blank"}
            href={item?.website}
            className="coupon-font coupon-website"
          >
            <b>{item?.Name}</b>
          </a>

          <div
            className={clsx(
              isCopied ? "copied" : "",
              "couponCopy flex-it flex-align-item-center flex-justify-center"
            )}
          >
            Copied
          </div>
        </div>
      </div>
    )
  );
};

export default CouponItem;
